<template>
    <div class="panel panel-primary">
        <div class="panel-heading primary centered">
            <h3 class="panel-title">Traffic Distribution Interval</h3>
            <div class="pull-right">
                <button class="btn btn-warning" @click.prevent="addPeriod">
                    <i class="fa fa-plus"></i>
                    Add period
                </button>
                <button :disabled="error && error.length > 0" type="submit" class="btn btn-success" @click.prevent="savePeriods">
                    <i class="fa fa-save"></i>
                    Save
                </button>

            </div>
        </div>
        <div class="panel-body">
            <div v-if="error" class="alert alert-danger" role="alert">
                {{error}}
            </div>
            <div v-if="message" class="alert alert-success" role="alert">
                {{message}}
            </div>
            <div :key="index"  v-for="(period, index) in periods" style="margin-top: 13px">
                <ServerToServerTrafficSettingPeriod
                    :index="index"
                    :from="formatDate(period.dateFrom)"
                    :to="formatDate(period.dateTo)"
                    :p="period.percentage"
                    @period-change="handlePeriodChange"
                />
                <button class="btn btn-danger" @click="removePeriod(index)">
                    <i class="fa fa-trash"></i>
                </button>
                <hr style="margin-top: 5px" />
            </div>
            <div class="col-md-6" v-if="!loading">
                <table class="table" style="margin-top: 21px;">
                    <thead class="thead-light">
                        <tr>
                            <th scope="col">Time From</th>
                            <th scope="col">Time To</th>
                            <th scope="col">Traffic Percentage {{percentageSum}}%</th>
                        </tr>
                    </thead>
                    <tbody>
                    <tr v-if="period.dateFrom && period.dateTo && period.percentage" :key="'period' + index" v-for="(period, index) in periods">
                        <td>{{ period.dateFrom && formatDate(period.dateFrom) }}</td>
                        <td>{{ period.dateTo && formatDate(period.dateTo) }}</td>
                        <td> {{period.percentage }} %</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>

import ServerToServerTrafficSettingPeriod from "./ServerToServerTrafficSettingPeriod";
export default {
    name: "ServerToServerTrafficSettings",
    components: {ServerToServerTrafficSettingPeriod},
    data() {
        return {
            periods: [],
            error: null,
            loading: false,
            message: null
        }
    },
    computed: {
        percentageSum() {
            return this.periods.reduce((sum, period) => sum + period.percentage, 0)
        }
    },
    created() {
        this.fetchTrafficSetting();
    },
    methods: {
        addPeriod() {
            this.message = null;
            const period = {
                'dateFrom': null,
                'dateTo': null,
                'percentage': null
            };
            this.periods.push(period);
        },
        removePeriod(index) {
            this.message = null;
            this.periods.splice(index, 1);
        },
        handlePeriodChange(dateFrom, dateTo, percentage, index) {
            let isValid = true;
            this.error = null;
            let percentageSum = 0;

            for (let currentIndex = 0; currentIndex < this.periods.length; currentIndex++) {

                let currentPeriod = this.periods[currentIndex];

                if(currentIndex === index) {
                    continue;
                }

                percentageSum += parseInt(currentPeriod.percentage);

                if(!currentPeriod.dateFrom || !currentPeriod.dateTo) {
                    isValid = false;
                }

                if (currentPeriod.dateFrom.isBefore(dateTo) && dateFrom.isBefore(currentPeriod.dateTo)) {
                    this.error = 'The period overlaps with another period.'
                    isValid = false;
                    break;
                }
            }

            if(percentageSum + parseInt(percentage) > 100) {
                this.error = 'Sum of percentages can not exceed 100';
                isValid = false;
            }

            if(!isValid) {
                //this.periods.splice(index, 1);
                return;
            }

            const period = {
                'dateFrom': dateFrom,
                'dateTo': dateTo,
                'percentage': parseInt(percentage)
            };

            this.$set(this.periods, index, period);

        },

        fetchTrafficSetting() {
            const url = '/server-to-server-traffic-settings'
            this.loading = true;

            axios.get(url, {
                periods: this.periods
            }).then((res) => {
                this.periods =  res.data.map(period => {
                    return {
                        dateFrom: moment.utc(period.dateFrom, 'hh:mm'),
                        dateTo: moment.utc(period.dateTo, 'hh:mm'),
                        percentage: period.percentage
                    }
                })
                this.loading = false;
            });
        },

        savePeriods() {
            const url = '/server-to-server-traffic-settings'

            axios.post(url, {
                periods: this.periods
            }).then(() => {
                this.message = 'Settings were update successfully!'
                this.fetchTrafficSetting();
            }).catch((err) => {
                this.error = err.errors.periods.message;
            });
        },

        formatDate(date) {
            if(!date) return;

            return date.format('HH:mm');
        }
    }
}
</script>

<style scoped>
 .centered {
     display: flex;
     flex-direction: row;
     justify-content: space-between;
     align-items: center;
 }
</style>



// WEBPACK FOOTER //
// resources/js/admin-panel/components/admin/traffic-settings/ServerToServerTrafficSettings.vue